const GAIL_BLUE_PLACEHOLDER = "\0gail-blue-skip:";

const GAIL_BLUE_PATTERN = /\(\(([\s\S]+?)\)\)/g;

function protectInlineCode(source: string, protectedSegments: string[]): string {
  return source.replace(/`[^`\n]+`/g, (match) => {
    const index = protectedSegments.push(match) - 1;
    return `${GAIL_BLUE_PLACEHOLDER}${index}`;
  });
}

function protectFencedCodeBlocks(
  source: string,
  protectedSegments: string[],
): string {
  return source.replace(/```[\s\S]*?```/g, (match) => {
    const index = protectedSegments.push(match) - 1;
    return `${GAIL_BLUE_PLACEHOLDER}${index}`;
  });
}

function restoreProtectedSegments(
  source: string,
  protectedSegments: string[],
): string {
  return source.replace(
    new RegExp(String.raw`${GAIL_BLUE_PLACEHOLDER}(\d+)`, "g"),
    (_, index) => protectedSegments[Number(index)] ?? "",
  );
}

/** Converts `((text))` and `((**bold**))` into GailBlue MDX spans. */
export function transformGailBlueMarkdown(source: string): string {
  const protectedSegments: string[] = [];

  let transformed = protectFencedCodeBlocks(source, protectedSegments);
  transformed = protectInlineCode(transformed, protectedSegments);
  transformed = transformed.replace(
    GAIL_BLUE_PATTERN,
    "<GailBlue>$1</GailBlue>",
  );

  return restoreProtectedSegments(transformed, protectedSegments);
}
